/*!
 * Copyright Optimus Ride 2019
 */

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/messaging';
import { FIREBASE_CONFIG, FIREBASE_PUBLIC_VAPID_KEY } from '../constants';

// TODO: This doesn't work in React Native web
firebase.initializeApp(FIREBASE_CONFIG);

const db = firebase.firestore();

// Messaging isn't support in all browsers. If it's not support, set `messaging` to `undefined`
const messaging = firebase.messaging.isSupported() ? firebase.messaging() : undefined;

if (messaging && FIREBASE_PUBLIC_VAPID_KEY) {
    messaging.usePublicVapidKey(FIREBASE_PUBLIC_VAPID_KEY);
}

export {
    db,
    firebase,
    messaging,
};
